import { Stack, Modal, Icon, Box, CircularProgress } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const ItemsListV2 = ({ items, itemsLoading, itemDetailed, closeDetailed, topChip }) => {
  return (
    <Stack spacing={2} sx={{ m: 1 }}>
      {itemDetailed ? (
        <Modal
          open={!!itemDetailed}
          sx={{
            zIndex: 1305,
          }}
        >
            {itemDetailed}
        </Modal>
      ) : null}
      {itemsLoading ? (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={"30px"} aria-label="Loading…" />
        </Box>
      ) : (
        items
      )}
    </Stack>
  );
};

export default ItemsListV2;
